import * as React from "react"
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Select,
  MenuItem,
  Button,
  Stack,
  Divider,
  LinearProgress,
  Alert,
} from "@mui/material"
import SaveIcon from "@mui/icons-material/Save"
import InfoIcon from "@mui/icons-material/Info"
import { api } from "../../function/axios"

export default function IrbiModelSelector() {
  const [active, setActive] = React.useState<string>("")
  const [models, setModels] = React.useState<string[]>([])
  const [loading, setLoading] = React.useState<boolean>(true)
  const [saving, setSaving] = React.useState<boolean>(false)
  const [error, setError] = React.useState<string | null>(null)
  const [info, setInfo] = React.useState<string | null>(null)

  React.useEffect(() => {
    let cancelled = false
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        const [curRes, allRes] = await Promise.all([
          await api({
            method: 'GET',
            url: '/ai-assistant/irbi_model',
          }),
          await api({
            method: 'GET',
            url: '/ai-assistant/irbi_models',
          }),
         
        ])
        if (!allRes.code) throw new Error(`GET /irbi/model → ${allRes.code}`)
        if (!curRes.code) throw new Error(`GET /irbi/model/openai → ${curRes.code}`)
        
        const allJson: { count: number; models: Array<{ id: string }> } = await allRes?.data
        const curJson: any = await curRes?.data

        const ids = Array.from(new Set(allJson.models.map(m => m.id))).sort((a, b) => a.localeCompare(b))
        if (!cancelled) {
          setModels(ids)
          setActive(curJson.env?.modelEnv || ids[0] || "")
        }
      } catch (e: any) {
        if (!cancelled) setError(e.message ?? String(e))
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => { cancelled = true }
  }, [])

  // const handleSetActive = async () => {
  //   if (!active) return
  //   setSaving(true)
  //   setError(null)
  //   setInfo(null)
  //   try {
  //     const res = await api({
  //       method: 'PUT',
  //       url: '/ai-assistant/irbi_model',
  //       headers: { "Content-Type": "application/json" },
  //       body: { model: active, persist: true },
  //     })
  //     if (!res.code) throw new Error(`PUT model → ${res.code}`)
  //     setInfo(`Model saved: ${active}`)
  //   } catch (e: any) {
  //     setError(e.message ?? String(e))
  //   } finally {
  //     setSaving(false)
  //   }
  // }

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 0,
        borderColor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.12)"
            : "rgba(0,0,0,0.12)",
      }}
    >
      <CardHeader
        title={<Typography variant="subtitle1" fontWeight={600}>Current Model</Typography>}
        //subheader={<Typography variant="caption" color="text.secondary">Switch the runtime model used for replies</Typography>}
        sx={{ pb: 1.5 }}
      />
      {(loading || saving) && <LinearProgress />}
      <Divider />

      <CardContent sx={{ p: 0.5 }}>
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}
          {info && <Alert severity="success">{info}</Alert>}

          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="body2" sx={{ minWidth: 90 }}>
              Active model:
            </Typography>
            <Select
              size="small"
              value={active}
              onChange={(e) => setActive(e.target.value as string)}
              sx={{ flex: 1 }}
              disabled
            >
              {models.map((m) => (
                <MenuItem key={m} value={m}>
                  {m}
                </MenuItem>
              ))}
            </Select>
          </Stack>

{/*
          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            <Button
              variant="outlined"
              color="info"
              startIcon={<InfoIcon />}
              sx={{ textTransform: "none" }}
              onClick={() => alert(`Current model: ${active || "(not set)"}`)}
              disabled={loading || saving}
            >
              Info
            </Button>

            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={handleSetActive}
              sx={{ textTransform: "none" }}
              disabled={loading || saving || !active}
            >
              Save
            </Button>
          </Stack>
          */}
        </Stack>
      </CardContent>
    </Card>
  )
}
